import React, {useState, useEffect, useRef} from "react";

export default function DraggableGhost({draggingItem, onDragEnd, initialPosition, ghost}) {
    const [draggingPosition, setDraggingPosition] = useState(initialPosition);
    const onDragEndRef = useRef(onDragEnd);

    onDragEndRef.current = onDragEnd;

    useEffect(() => {
        function handleMouseMove(e) {
            setDraggingPosition({x: e.clientX, y: e.clientY});
        }

        function handleMouseUp() {
            onDragEndRef.current();
        }

        if (draggingItem) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        }

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [draggingItem]);

    return (
        <>
            {!!draggingItem && (
                <div
                    style={{
                        position: "fixed",
                        left: draggingPosition.x,
                        top: draggingPosition.y,
                        pointerEvents: "none",
                        color: "white",
                        transform: "rotate(1.5deg)",
                        width: "100VH",
                        zIndex: 1000,
                    }}
                >
                    {ghost}
                </div>
            )}
        </>
    );
}
